import { Navigate, Outlet, useLocation } from "react-router-dom";
import { DesktopInstallHost } from "../components/local-engine/DesktopInstallHost";
import { HardwareDesktopGate } from "../components/local-engine/HardwareDesktopGate";
import { PosOfflineSync } from "../components/pos/PosOfflineSync";
import { AiInspectorProvider } from "../context/AiInspectorContext";
import { isOpsPortalHost, opsPortalPath } from "../lib/ops-host";

/** ERP shell must never render on usr.godo-erp.com (same Pages build). */
export function OpsHostRedirect() {
  const location = useLocation();
  if (!isOpsPortalHost()) return <Outlet />;
  return (
    <Navigate
      to={`${opsPortalPath("sheet")}${location.search}${location.hash}`}
      replace
    />
  );
}

export function AppRoot() {
  return (
    <AiInspectorProvider>
      <Outlet />
      <HardwareDesktopGate />
      <DesktopInstallHost />
      <PosOfflineSync />
    </AiInspectorProvider>
  );
}
